import React, { useEffect, useState } from "react";
import OnlineLeadDetails from "./OnlineLeadDetails";
import { getPersonelList } from "../../../../api/LoginAPI";
import { useFromUser } from "../../../../stores/LocalStorageHelper";
import { personnelType } from "../../../../constants/Constants";

const OnlineLeadDetailsPage = () => {
	const locationID = useFromUser("locationID");
	const [salesPeople, setSalesPeople] = useState([]);

	useEffect(() => {
		getPersonelList(locationID).then((res) => {
			const salespeopleList = res.data.content
				.filter((obj) => !obj.isHidden)
				.map((obj) => ({
					label: `${obj.firstName} ${obj.lastName} - ${
						personnelType.find((pt) => pt.value === obj.personnelType)?.label
					}`,
					value: obj.ID,
					dcLogin: obj,
				}));

			salespeopleList.push({
				label: "None",
				value: 0,
				dcLogin: null,
			});
			setSalesPeople(salespeopleList);
		});

		// eslint-disable-next-line
	}, []);

	return <OnlineLeadDetails salesPeople={salesPeople} />;
};

export default OnlineLeadDetailsPage;
